import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

const AddUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        duration_minutes: '',
        is_active: true
    });

    useEffect(() => {
        if (id) {
            getSingleData();
        }
    }, [id]);

    const getSingleData = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: 'GET',
                url: `/admin/services/${id}`
            });
            if (response.data.status) {
                setFormData(response.data.data);
            } else {
                toast.error(response.data.message);
                navigate('/services');
            }
        } catch (error) {
            toast.error('Failed to fetch data');
            navigate('/services');
        } finally {
            setIsLoader(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: id ? 'PUT' : 'POST',
                url: id ? `/admin/services/${id}` : '/admin/services',
                data: formData
            });
            if (response.data.status) {
                toast.success(response.data.message);
                navigate('/services');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Something went wrong');
            if (error.response && error.response.data && error.response.data.errors) {
                // Handle validation errors if needed
            }
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            {id ? 'Edit Service' : 'Add Service'}
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/services" className="btn btn-sm fw-bold btn-secondary">
                            Back
                        </Link>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                        <div className="card-body py-4">
                            {isLoader ? <Loader /> : (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label required">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label required">Price</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="price"
                                                value={formData.price}
                                                onChange={handleChange}
                                                required
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label required">Duration (minutes)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="duration_minutes"
                                                value={formData.duration_minutes}
                                                onChange={handleChange}
                                                required
                                                min="1"
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3 form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="is_active"
                                            name="is_active"
                                            checked={formData.is_active}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="is_active">
                                            Active
                                        </label>
                                    </div>
                                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                                        {id ? 'Update' : 'Submit'}
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUpdate;
